import qs from 'query-string';

export function loadRecentlyViewedFromLocalStorage() {
    let recentlyViewedClients = JSON.parse(localStorage.getItem('recentlyViewedClients')) || [];

    return {
        recentlyViewedClients,
        type: 'LOAD_RECENTLY_VEIWED_CLIENTS'
    };
}

export function loadDudReasons() {
    return (dispatch, getState) => {
        if(! getState().dudReasons.loaded) {
            dispatch({
                types: ['LOAD_DUD_REASON', 'LOAD_DUD_REASON_SUCCESS', 'LOAD_DUD_REASON_FAIL'],
                promise: (api) => api.get('client_close_off_reasons')
            });
        }
    };
}

export function updateInterestNotes(clientId, interestNotes) {
    return {
        types: ['UPDATE_INTEREST_NOTES', 'UPDATE_INTEREST_NOTES_SUCCESS', 'UPDATE_INTEREST_NOTES_FAIL'],
        promise: (api) => api.put(`clients/${clientId}/interest_notes`, {interestNotes})
    };
}

export function recordGoLiveDate(clientId, goLiveDate) {
    return {
        types: ['RECORD_GO_LIVE_DATE', 'RECORD_GO_LIVE_DATE_SUCCESS', 'RECORD_GO_LIVE_DATE_FAIL'],
        promise: (api) => api.put(`clients/${clientId}/go_live_date`, {goLiveDate})
    };
}

export function markAsQualified(clientId) {
    return {
        types: ['MARK_QUALIFIED_AT', 'MARK_QUALIFIED_AT_SUCCESS', 'MARK_QUALIFIED_AT_FAIL'],
        promise: (api) => api.put(`clients/${clientId}/mark_as_qualified`)
    };
}

export function migrateBillingRegion(clientId, billingRegion, shouldDeleteCreditCard) {
    let newClientBillingRegionId = billingRegion.billingRegionId;
    return {
        billingRegion,
        types: ['MIGRATE_BILLING_REGION', 'MIGRATE_BILLING_REGION_SUCCESS', 'MIGRATE_BILLING_REGION_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/migrate_billing_region`, {newClientBillingRegionId, shouldDeleteCreditCard})
    };
}

export function disableEmployee(clientId, employeeId) {
    return {
        types: ['DISABLE_EMPLOYEE', 'DISABLE_EMPLOYEE_SUCCESS', 'DISABLE_EMPLOYEE_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/disable_employee`, {employeeId})
    };
}

export function reenableEmployee(clientId, employeeId) {
    return {
        types: ['REENABLE_EMPLOYEE', 'REENABLE_EMPLOYEE_SUCCESS', 'REENABLE_EMPLOYEE_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/reenable_employee`, {employeeId})
    };
}

export function updateLockStatus(clientId, newLockStatus) {
    return {
        newLockStatus,
        types: ['UPDATE_LOCK_STATUS', 'UPDATE_LOCK_STATUS_SUCCESS', 'UPDATE_LOCK_STATUS_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/lock_status`, {newLockStatus})
    };
}

export function updateDiscount(clientId, newDiscount) {
    return {
        newDiscount,
        types: ['UPDATE_DISCOUNT', 'UPDATE_DISCOUNT_SUCCESS', 'UPDATE_DISCOUNT_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/discount`, {newDiscount})
    };
}

export function updateInterestLevel(clientId, interestLevel) {
    var interestLevelId = interestLevel.id;
    return {
        interestLevel,
        types: ['UPDATE_INTEREST_LEVEL', 'UPDATE_INTEREST_LEVEL_SUCCESS', 'UPDATE_INTEREST_LEVEL_FAIL'],
        promise: (api) => api.put(`clients/${clientId}/interest_level`, {interestLevelId})
    };
}

export function loadClients() {
    return {
        types: ['CLIENTS_LOAD', 'CLIENTS_LOAD_SUCCESS', 'CLIENTS_LOAD_FAIL'],
        promise: (api) => api.post('clients/search?page=1')
    };
}

export function searchEntities(searchText) {
    return {
        types: ['SEARCH_ENTITIES', 'SEARCH_ENTITIES', 'SEARCH_ENTITIES'],
        promise: (api) => api.post('clients/search', {searchText})
    };
}

export function searchClients(search) {
    var search = search || {searchText: '', page: 1};

    return {
        types: ['SEARCH_CLIENTS', 'SEARCH_CLIENTS_SUCCESS', 'SEARCH_CLIENTS_FAIL'],
        promise: (api) => api.post('clients/search', search)
    };
}


export function unmarkAsDud(clientId) {
    return {
        types: ['UNMARK_AS_DUD', 'UNMARK_AS_DUD_SUCCESS', 'UNMARK_AS_DUD_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/restore`)
    };
}

export function markAsDud(clientId, data) {
    return {
        types: ['MARK_AS_DUD', 'MARK_AS_DUD_SUCCESS', 'MARK_AS_DUD_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/mark_as_dud`, data)
    };
}

export function markAsNotDuplicate(clientId1, clientId2) {
    return {
        types: ['MARK_AS_NOT_DUPLICATE', 'MARK_AS_NOT_DUPLICATE_SUCCESS', 'MARK_AS_NOT_DUPLICATE_FAIL'],
        promise: (api) => api.post(`clients/${clientId1}/mark_as_not_duplicate`, {clientId2})
    };
}

export function qualifyClient(data){
    return {
        types: ['QUALIFY_CLIENT', 'QUALIFY_CLIENT_SUCCESS', 'QUALIFY_CLIENT_FAIL'],
        promise: (api) => api.post(`clients/${data.clientId}/qualify`, data)
    };
}

export function freePlanTypeClient(data){
    return {
        types: ['FREE_PLAN_TYPE_CLIENT', 'FREE_PLAN_TYPE_CLIENT_SUCCESS', 'FREE_PLAN_TYPE_CLIENT_FAIL'],
        promise: (api) => api.post(`clients/${data.clientId}/free_plan_type`, data)
    };
}

export function loadActiveUser(userId) {
    return {
        types: ['ACTIVE_USER_LOAD', 'ACTIVE_USER_LOAD_SUCCESS', 'ACTIVE_USER_LOAD_FAIL'],
        promise: (api) => api.get(`users/${userId}`)
    };
}

export function updateUsersAssignedToClient(clientId, userIdsAssigned) {
    return {
        types: ['UPDATE_USERS_ASSIGNED_TO_CLIENT', 'UPDATE_USERS_ASSIGNED_TO_CLIENT_SUCCESS', 'UPDATE_USERS_ASSIGNED_TO_CLIENT_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/users_assigned`, {userIdsAssigned})
    };
}

// only load staff
export function loadUsers() {
    return {
        types: ['USER_LOAD', 'USER_LOAD_SUCCESS', 'USER_LOAD_FAIL'],
        promise: (api) => api.get(`users`)
    };
}

export function loadActiveClient(clientId) {
    return {
        types: ['ACTIVE_CLIENT_LOAD', 'ACTIVE_CLIENT_LOAD_SUCCESS', 'ACTIVE_CLIENT_LOAD_FAIL'],
        promise: (api) => api.get(`clients/${clientId}`)
    };
}

var defaultQuery = {
    page: 1,
    showNotes: true,
    showEmails: true,
    showActivity: true,
    showUserVoice: true,
    showCalls: true,
    showMeetings: true
};

export function loadClientEvents(clientId, query = defaultQuery) {
    var queryString = qs.stringify(query);
    return {
        types: ['ACTIVE_CLIENT_EVENTS_LOAD', 'ACTIVE_CLIENT_EVENTS_LOAD_SUCCESS', 'ACTIVE_CLIENT_EVENTS_LOAD_FAIL'],
        promise: (api) => api.get(`clients/${clientId}/events?${queryString}`)
    };
}

export function loadClientContacts(clientId) {
    return {
        types: ['ACTIVE_CLIENT_CONTACTS_LOAD', 'ACTIVE_CLIENT_CONTACTS_LOAD_SUCCESS', 'ACTIVE_CLIENT_CONTACTS_LOAD_FAIL'],
        promise: (api) => api.get(`clients/${clientId}/contacts`)
    };
}

export function createSchedule(scheduleData) {
    return {
        types: ['CREATE_SCHEDULE', 'CREATE_SCHEDULE_SUCCESS', 'CREATE_SCHEDULE_FAIL'],
        promise: (api) => api.post('schedules', scheduleData)
    };
}

export function changeMiddysStatus(clientId, data) {
    return {
        types: ['CHANGE_MIDDYS_STATUS', 'CHANGE_MIDDYS_STATUS_SUCCESS', 'CHANGE_MIDDYS_STATUS_FAIL'],
        promise: (api) => api.put(`clients/${clientId}/middys_status`, data)
    };
}

export function updateSchedule(scheduleId, scheduleData) {
    return {
        types: ['UPDATE_SCHEDULE', 'UPDATE_SCHEDULE_SUCCESS', 'UPDATE_SCHEDULE_FAIL'],
        promise: (api) => api.put(`schedules/${scheduleId}`, scheduleData)
    };
}

export function updateClientStage(clientId, clientStageId) {
    return {
        types: ['UPDATE_CLIENT_STAGE', 'UPDATE_CLIENT_STAGE_SUCCESS', 'UPDATE_CLIENT_STAGE_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/client_stage`, { clientStageId: clientStageId })
    };
}

export function deleteSchedule(scheduleId, type) {
    return {
        types: ['DELETE_SCHEDULE', 'DELETE_SCHEDULE_SUCCESS', 'DELETE_SCHEDULE_FAIL'],
        promise: (api) => api.delete(`schedules/${scheduleId}`, {type})
    };
}

export function markScheduleAsComplete(scheduleId) {
    return {
        types: ['MARK_SCHEDULE_COMPLETE', 'SCHEDULE_MARKED_COMPLETE_SUCCESS', 'MARK_SCHEDULE_COMPLETE_FAIL'],
        promise: (api) => api.post('schedules/markAsComplete', {scheduleId})
    };
}

export function recordPhoneCallCompleted(id, callData) {
    return {
        types: ['RECORD_PHONE_CALL_COMPLETE', 'RECORD_PHONE_CALL_COMPLETE_SUCCESS', 'RECORD_PHONE_CALL_COMPLETE_FAIL'],
        promise: (api) => api.post(`phone_calls/${id}/record_completed`, callData)
    };
}

export function deleteNote(noteId) {
    return {
        types: ['DELETE_NOTE', 'DELETE_NOTE_SUCCESS', 'DELETE_NOTE_FAIL'],
        promise: (api) => api.post('notes/delete', {noteId})
    };
}

export function clearOutActiveClientContacts() {
    return {type: 'CLEAR_OUT_ACTIVE_CLIENT_CONTACTS'};
}

export function createNote(noteData) {
    return {
        types: ['CREATE_NOTE', 'CREATE_NOTE_SUCCESS', 'CREATE_NOTE_FAIL'],
        promise: (api) => api.post('notes', noteData)
    };
}

export function createOrUpdateGlobalNote(clientId, noteData) {
    return {
        types: ['CREATE_GLOBAL_NOTE', 'CREATE_GLOBAL_NOTE_SUCCESS', 'CREATE_GLOBAL_NOTE_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/global_notes`, {note: noteData})
    };
}

export function createCompletedPhoneCall(callData) {
    return {
        types: ['CREATE_NOTE', 'CREATE_NOTE_SUCCESS', 'CREATE_NOTE_FAIL'],
        promise: (api) => api.post('completed_phone_call', callData)
    };
}

export function updateNote(noteId, noteData) {
    return {
        types: ['UPDATE_NOTE', 'UPDATE_NOTE_SUCCESS', 'UPDATE_NOTE_FAIL'],
        promise: (api) => api.put(`notes/${noteId}`, noteData)
    };
}

export function createContact(clientId, contactData) {
    return {
        types: ['CREATE_CONTACT', 'CREATE_CONTACT_SUCCESS', 'CREATE_CONTACT_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/contact`, contactData)
    };
}

export function updateContact(contactId, contactData) {
    return {
        types: ['UPDATE_CONTACT', 'UPDATE_CONTACT_SUCCESS', 'UPDATE_CONTACT_FAIL'],
        promise: (api) => api.post(`contact/${contactId}/update`, contactData)
    };
}

export function resizeClientsTableColumn(newColumnWidth, columnKey) {
    return {
        type: 'RESIZE_CLIENTS_TABLE_COLUMN',
        columnData: {columnKey, newColumnWidth}
    };
}



export function toggleFilterVisible(lookupKey) {
    return {
        type: 'TOGGLE_CLIENTS_FILTER_VISIBLE',
        lookupKey
    };
}

export function toggleClientsTableColumnFixed(columnId) {
    return {
        type: 'TOGGLE_CLIENTS_TABLE_COLUMN_FIXED',
        columnId
    };
}

export function toggleClientsTableColumnVisible(columnId) {
    return {
        type: 'TOGGLE_CLIENTS_TABLE_COLUMN_VISIBLE',
        columnId
    };
}

export function changeClientSortOrder(columnId, sortDir) {
    return {
        type: 'CHANGE_CLIENTS_TABLE_COLUMN_SORT_ORDER',
        columnId,
        sortDir
    };
}

export function setTrialExpiry(data){
    return {
        types: ['SET_TRIAL_EXPIRY', 'SET_TRIAL_EXPIRY_SUCCESS', 'SET_TRIAL_EXPIRY_FAIL'],
        promise: (api) => api.post(`clients/${data.clientId}/update_trial_expiry`, data)
    };
}

export function changeToTrial(data) {
    return {
        types: ['CHANGE_TO_TRIAL', 'CHANGE_TO_TRIAL_SUCCESS', 'CHANGE_TO_TRIAL_FAIL'],
        promise: (api) => api.post(`clients/${data.clientId}/change_to_trial`, data)
    };
}

export function loadCreditHistory(clientId) {
    return {
        types: ['LOAD_CREDIT_HISTORY', 'LOAD_CREDIT_HISTORY_SUCCESS', 'LOAD_CREDIT_HISTORY_FAIL'],
        promise: (api) => api.get(`clients/${clientId}/credit`)
    };
}

export function loadActiveBillingRegions(clientId) {
    return {
        types: ['BILLING_REGIONS_LOAD', 'BILLING_REGIONS_LOAD_SUCCESS', 'BILLING_REGIONS_LOAD_FAIL'],
        promise: (api) => api.get(`clients/${clientId}/active_billing_regions`)
    };
}

export function createCreditItem(clientId, data) {
    return {
        types: ['CREATE_CREDIT_ITEM', 'CREATE_CREDIT_ITEM_SUCCESS', 'CREATE_CREDIT_ITEM_FAIL'],
        promise: (api) => api.post(`clients/${clientId}/credit`, data)
    };
}

export function detectDuplicates(clientId){
    return {
        types: ['DETECT_DUPLICATES', 'DETECT_DUPLICATES_SUCCESS', 'DETECT_DUPLICATES_FAIL'],        
        promise: (api) => api.get(`clients/${clientId}/duplicates`)
    };
}

export function deleteContact(contactId) {
    return {
        types: ['DELETE_CONTACT', 'DELETE_CONTACT_SUCCESS', 'DELETE_CONTACT_FAIL'],
        promise: (api) => api.delete(`contacts/${contactId}`)
    };
}

var fetchNonCriticalClientInfo = (clientId, dispatch) => {
    dispatch(loadClientEvents(clientId));
    dispatch(detectDuplicates(clientId));
};

export function fetchClient(clientId) {
    return (dispatch, getState) => {
        const promises = [
            dispatch(loadActiveClient(clientId)),
            dispatch(loadClientContacts(clientId)),
        ];

        fetchNonCriticalClientInfo(clientId, dispatch);

        return Promise.all(promises);
    };
}



// WEBPACK FOOTER //
// ./app/actions/ClientActions.js